(() => {
  const initPurchaseOptionsWidget = (widget) => {
    if (!widget || widget.dataset.initialized === 'true') return true;

    const sectionId = widget.dataset.sectionId;
    if (!sectionId) return false;

    const form = document.getElementById(`product-form-${sectionId}`);
    if (!form) return false;

    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return false;

    widget.dataset.initialized = 'true';

    let currentVariantId = widget.dataset.currentVariantId || variantInput.value;
    const updatedGalleryImages = new Set();

    const getSellingPlanInput = () => {
      let input = form.querySelector('input[name="selling_plan"]');

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        form.appendChild(input);
      }

      return input;
    };

    const setSellingPlan = (sellingPlanId) => {
      const input = getSellingPlanInput();

      if (sellingPlanId) {
        input.value = sellingPlanId;
        input.disabled = false;
      } else {
        input.value = '';
        input.disabled = true;
      }
    };

    const cacheOriginalImage = (image) => {
      if (image.dataset.purchaseOptionsOriginalSrc !== undefined) return;

      image.dataset.purchaseOptionsOriginalSrc = image.getAttribute('src') || '';
      image.dataset.purchaseOptionsOriginalSrcset = image.getAttribute('srcset') || '';
      image.dataset.purchaseOptionsOriginalAlt = image.getAttribute('alt') || '';
    };

    const restoreGalleryImages = () => {
      updatedGalleryImages.forEach((image) => {
        if (!image.isConnected) return;

        if (image.dataset.purchaseOptionsOriginalSrcset) {
          image.setAttribute('srcset', image.dataset.purchaseOptionsOriginalSrcset);
        } else {
          image.removeAttribute('srcset');
        }

        if (image.dataset.purchaseOptionsOriginalSrc) {
          image.setAttribute('src', image.dataset.purchaseOptionsOriginalSrc);
        }

        image.setAttribute('alt', image.dataset.purchaseOptionsOriginalAlt || '');
      });

      updatedGalleryImages.clear();
    };

    const updateGalleryImage = (useBundleImage) => {
      restoreGalleryImages();

      if (!useBundleImage || !widget.dataset.bundleImageSrc) return;

      const mediaGallery = document.getElementById(`MediaGallery-${sectionId}`);
      const activeMedia = mediaGallery?.querySelector('.product__media-item.is-active')
        || mediaGallery?.querySelector('[id^="Slider-Gallery"] [data-media-id]');
      const activeImage = activeMedia?.querySelector('.product__media img');

      if (!activeImage) return;

      cacheOriginalImage(activeImage);
      updatedGalleryImages.add(activeImage);

      if (widget.dataset.bundleImageSrcset) {
        activeImage.setAttribute('srcset', widget.dataset.bundleImageSrcset);
      }

      activeImage.setAttribute('src', widget.dataset.bundleImageSrc);
      activeImage.setAttribute('alt', widget.dataset.bundleImageAlt || '');
    };

    const applySelection = () => {
      const selectedOption = widget.querySelector('.pdp-purchase-options__input:checked');
      if (!selectedOption) return;

      if (selectedOption.value === 'bundle') {
        if (!widget.dataset.bundleVariantId) return;
        variantInput.value = widget.dataset.bundleVariantId;
        setSellingPlan(widget.dataset.bundleSellingPlanId);
        updateGalleryImage(true);
        return;
      }

      variantInput.value = currentVariantId;
      setSellingPlan(
        selectedOption.value === 'subscription'
          ? widget.dataset.subscriptionSellingPlanId
          : ''
      );
      updateGalleryImage(false);
    };

    widget.addEventListener('change', applySelection);

    document.addEventListener('change', (event) => {
      if (!event.target.closest(`variant-radios[data-section="${sectionId}"], variant-selects[data-section="${sectionId}"]`)) return;

      window.setTimeout(() => {
        currentVariantId = variantInput.value;
        applySelection();
      }, 0);
    });

    applySelection();
    return true;
  };

  const initPurchaseOptionsWidgets = (container = document) => {
    container.querySelectorAll('[data-purchase-options-widget]').forEach(initPurchaseOptionsWidget);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initPurchaseOptionsWidgets(), { once: true });
  } else {
    initPurchaseOptionsWidgets();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initPurchaseOptionsWidgets(event.target);
  });
})();
